import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/mulch-calculator',
  component: () => import('../../routes/MulchCalculator.svelte'),
  card: {
    id: 'mulch-calculator',
    title: 'Mulch Calculator',
    description:
      'Calculate how much mulch, bark, cedar, hardwood, rubber, or straw you need for your garden beds. Get volume in cubic yards/cubic feet, weight, bag counts, and cost.',
    icon: 'park',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/mulch-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Mulch Calculator – Estimate Bags, Cubic Yards, and Cost',
    description:
      'Free mulch calculator to estimate cubic yards, cubic feet, weight, bag counts, and cost for garden beds. Supports bark, cedar, hardwood, rubber, and straw mulch.',
  },
};

export default meta;
